import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';
import classNames from './Icon.module.scss';

export const IconPremiumRights = ({ style, grow }: SVGIconProps) => {
  return (
    <Center style={style} classNames={classNames} data-grow={grow}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <ellipse cx="13.125" cy="12" rx="7.875" ry="9" fill="#FFD880" />
        <path
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8 9.00016C14.6188 8.68592 14.3557 8.42686 14.0386 8.25071C13.7215 8.07456 13.3625 7.98795 13 8.00016H11C10.4696 8.00016 9.96086 8.21087 9.58579 8.58594C9.21071 8.96102 9 9.46972 9 10.0002C9 10.5306 9.21071 11.0393 9.58579 11.4144C9.96086 11.7894 10.4696 12.0002 11 12.0002H13C13.5304 12.0002 14.0391 12.2109 14.4142 12.5859C14.7893 12.961 15 13.4697 15 14.0002C15 14.5306 14.7893 15.0393 14.4142 15.4144C14.0391 15.7894 13.5304 16.0002 13 16.0002H11C10.6375 16.0124 10.2785 15.9258 9.96142 15.7496C9.64435 15.5735 9.38115 15.3144 9.2 15.0002"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 6V8M12 16V18"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Center>
  );
};
